/* =============================================
   BRYA-STYLE THEME — MAIN JS
   ============================================= */

document.addEventListener('DOMContentLoaded', () => {

  // ── THEME TOGGLE ──────────────────────────────────
  const themeToggle = document.getElementById('theme-toggle');
  if (themeToggle) {
    themeToggle.addEventListener('click', () => {
      document.body.classList.toggle('dark-mode');
      localStorage.setItem('theme', document.body.classList.contains('dark-mode') ? 'dark' : 'light');
    });
  }
  // Restore saved theme
  const savedTheme = localStorage.getItem('theme');
  if (savedTheme === 'dark') {
    document.body.classList.add('dark-mode');
  } else if (savedTheme === 'light') {
    document.body.classList.remove('dark-mode');
  }

  // ── MOBILE NAV ────────────────────────────────────
  const hamburger = document.getElementById('hamburger');
  const mobileNav = document.getElementById('mobile-nav');
  const mobileNavClose = document.getElementById('mobile-nav-close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileNavClose && mobileNav) {
    mobileNavClose.addEventListener('click', () => {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }
  // Close on link click
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(link => {
      link.addEventListener('click', () => {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── CART DRAWER ───────────────────────────────────
  const cartDrawer = document.getElementById('cart-drawer');
  const cartBtn = document.getElementById('cart-btn');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartOverlay = document.querySelector('.cart-drawer__overlay');

  function openCart() {
    cartDrawer && cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartBtn && cartBtn.addEventListener('click', openCart);
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  // ── FAQ ACCORDION ─────────────────────────────────
  document.querySelectorAll('.faq__question').forEach(question => {
    question.addEventListener('click', () => {
      const item = question.closest('.faq__item');
      const isOpen = item.classList.contains('open');
      // Close all
      document.querySelectorAll('.faq__item.open').forEach(i => i.classList.remove('open'));
      // Open clicked (unless it was already open)
      if (!isOpen) item.classList.add('open');
    });
  });

  // ── SCROLL REVEAL ─────────────────────────────────
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry, i) => {
      if (entry.isIntersecting) {
        setTimeout(() => {
          entry.target.classList.add('revealed');
        }, entry.target.dataset.delay || 0);
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 });

  document.querySelectorAll('[data-reveal]').forEach((el, i) => {
    el.dataset.delay = i * 80;
    revealObserver.observe(el);
  });

  // ── COLOR SHOWCASE INTERACTION ────────────────────
  const colorItems = document.querySelectorAll('.color-item');
  const showcaseImg = document.getElementById('showcase-img');

  colorItems.forEach(item => {
    item.addEventListener('click', () => {
      colorItems.forEach(i => i.classList.remove('active'));
      item.classList.add('active');
      if (showcaseImg) {
        const imgSrc = item.dataset.img;
        if (imgSrc) {
          showcaseImg.style.opacity = '0';
          setTimeout(() => {
            showcaseImg.src = imgSrc;
            showcaseImg.style.opacity = '1';
          }, 200);
        }
      }
    });
  });

  // Set first active
  if (colorItems.length > 0 && !document.querySelector('.color-item.active')) {
    colorItems[0].classList.add('active');
  }

  // ── VARIANT SELECTION ─────────────────────────────
  document.querySelectorAll('.variant-option').forEach(opt => {
    opt.addEventListener('click', () => {
      const group = opt.closest('.variant-options');
      group.querySelectorAll('.variant-option').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
    });
  });

  document.querySelectorAll('.color-option').forEach(opt => {
    opt.addEventListener('click', () => {
      const group = opt.closest('.color-options');
      group.querySelectorAll('.color-option').forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
    });
  });

  // ── GALLERY THUMBS ────────────────────────────────
  document.querySelectorAll('.product-gallery__thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-gallery');
      gallery.querySelectorAll('.product-gallery__thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = gallery.querySelector('.product-gallery__main img');
      if (mainImg && thumb.dataset.src) {
        mainImg.src = thumb.dataset.src;
      }
    });
  });

  // ── ADD TO CART ───────────────────────────────────
  document.querySelectorAll('.js-add-to-cart').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      const qty = parseInt(btn.dataset.qty || 1);

      btn.disabled = true;
      btn.textContent = 'Adding...';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: qty })
        });

        if (res.ok) {
          btn.textContent = 'Added!';
          await updateCartCount();
          setTimeout(() => { openCart(); }, 300);
        } else {
          btn.textContent = 'Error';
        }
      } catch {
        btn.textContent = 'Error';
      }

      setTimeout(() => {
        btn.disabled = false;
        btn.textContent = btn.dataset.label || 'Add to Cart';
      }, 2000);
    });
  });

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = cart.item_count;
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count;
        el.classList.toggle('visible', count > 0);
      });
    } catch {}
  }

  updateCartCount();

  // ── HEADER SCROLL EFFECT ─────────────────────────
  const header = document.querySelector('.site-header');
  let lastScroll = 0;
  window.addEventListener('scroll', () => {
    const current = window.scrollY;
    if (header) {
      header.style.boxShadow = current > 20 ? 'var(--shadow-md)' : '';
    }
    lastScroll = current;
  }, { passive: true });

  // ── HERO PARALLAX (subtle) ────────────────────────
  const heroBg = document.querySelector('.hero__bg-video, .hero__bg-img');
  if (heroBg) {
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      if (scrolled < window.innerHeight) {
        heroBg.style.transform = `translateY(${scrolled * 0.2}px)`;
      }
    }, { passive: true });
  }

});
